import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private hideSideBar = new BehaviorSubject<boolean>(false);
  currentValue = this.hideSideBar.asObservable();

  updateHideSideBarValue() {    
    const value = this.hideSideBar.getValue();    
    this.hideSideBar.next(!value);
    console.log('newValue: ', this.hideSideBar.getValue());
  }
}